import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Review routes
const CustomerWiseLead = Loader(
  lazy(
    () =>
      import(
        'src/content/admin-content/Review&RatingManagement/review&rating/index'
      )
  )
);

const reviewRatingRoutesAdmin = [
  {
    path: '',
    element: <Navigate to="review-and-rating" replace />
  },
  {
    path: 'review-and-rating',
    element: <CustomerWiseLead />
  }
];

export default reviewRatingRoutesAdmin;
